var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#1DA1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.115C10.108 17.115 8.36701 16.165 7.34401 14.571C7.12001 14.223 7.22101 13.761 7.57001 13.536C7.91801 13.31 8.38201 13.412 8.60601 13.762C9.35301 14.924 10.622 15.617 12.001 15.617C13.38 15.617 14.649 14.924 15.397 13.763C15.621 13.413 16.085 13.313 16.433 13.538C16.783 13.762 16.883 14.226 16.659 14.574C15.634 16.168 13.893 17.119 12.001 17.119L12 17.115Z",
    fill: "#1DA1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.738 10.936C15.5543 10.936 16.216 10.2743 16.216 9.45801C16.216 8.64173 15.5543 7.98001 14.738 7.98001C13.9217 7.98001 13.26 8.64173 13.26 9.45801C13.26 10.2743 13.9217 10.936 14.738 10.936Z",
    fill: "#1DA1F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.262 10.936C10.0783 10.936 10.74 10.2743 10.74 9.45801C10.74 8.64173 10.0783 7.98001 9.262 7.98001C8.44572 7.98001 7.784 8.64173 7.784 9.45801C7.784 10.2743 8.44572 10.936 9.262 10.936Z",
    fill: "#1DA1F2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEmoji);
export default __webpack_public_path__ + "static/media/shareEmoji.b79c9043f2a9facb572ed4c9770e4b6c.svg";
export { ForwardRef as ReactComponent };